import { useEffect, useState } from "react";
import { api } from "@/api/client";
import { toast } from "sonner";

/**
 * Shared work-sample-selection logic (2026-09-27, extracted for NJM Build Opportunities'
 * OpportunityApplyModal to reuse WITHOUT copy-pasting ApplyToSlotModal.jsx — see that file and
 * OpportunityApplyModal.jsx for the two markup variants, which stay intentionally different
 * (checkbox list vs thumbnail tiles) per each surface's own approved mockup). Fetches the
 * freelancer's OWN, EXISTING `freelancer_work_samples` (never a re-upload) via the SAME
 * GET /v1/build/my-work-samples every other picker here already uses.
 */
export function useWorkSampleSelection(maxCount = 3, limitMessage) {
  const [samples, setSamples] = useState(null);
  const [selected, setSelected] = useState([]);

  useEffect(() => {
    api.get("/v1/build/my-work-samples").then((r) => setSamples(r.data.items || [])).catch(() => setSamples([]));
  }, []);

  const toggle = (id) => {
    setSelected((prev) => {
      if (prev.includes(id)) return prev.filter((x) => x !== id);
      if (prev.length >= maxCount) { toast.error(limitMessage || `Pick up to ${maxCount} samples`); return prev; }
      return [...prev, id];
    });
  };

  return { samples, selected, toggle, loading: samples === null };
}
